import React from 'react';
import { Text } from '@atlassian/learning-components';

export const LEARNING_LICENSE_DATA = {
  modalTitle: 'About Learning',
  bodyTitle: 'License Information for Learning Platform',
  bodyDescription: <Text>Copyright © 2025 Atlassian.</Text>,
  licenses: [
    {
      packageName: '@compiled/react',
      version: 'v0.17.0',
      link: 'https://compiledcssinjs.com/docs/pkg-react',
      description: `   Copyright 2019-Present Atlassian Pty Ltd
                                     Apache License
                           Version 2.0, January 2004
                        http://www.apache.org/licenses/`,
    },
    {
      packageName: '@contentful/live-preview',
      version: 'v2.14.0',
      link: 'https://github.com/contentful/live-preview',
      description: `MIT License

Copyright (c) 2023 Contentful

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE`,
    },
    {
      packageName: '@contentful/rich-text-from-markdown',
      version: 'v15.18.10',
      link: 'https://github.com/contentful/rich-text#readme',
      description: `MIT License

Copyright (c) 2018 Contentful

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE`,
    },
    {
      packageName: '@contentful/rich-text-react-renderer',
      version: 'v15.12.1',
      link: 'https://github.com/contentful/rich-text.git',
      description: `MIT License

Copyright (c) 2018 Contentful

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE`,
    },
    {
      packageName: '@playwright/test',
      version: 'v1.44.1',
      link: 'https://playwright.dev',
      description: `                                 Apache License
                           Version 2.0, January 2004
                        ${`http://www.apache.org/licenses/`}`,
    },
    {
      packageName: '@sentry/react',
      version: 'v8.51.0',
      link: 'https://github.com/getsentry/sentry-javascript?tab=MIT-1-ov-file#readme',
      description: `MIT License

Copyright (c) 2012 Functional Software, Inc. dba Sentry

Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the "Software"), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
of the Software, and to permit persons to whom the Software is furnished to do
so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.`,
    },
    {
      packageName: '@testing-library/react-hooks',
      version: 'v8.0.1',
      link: 'https://github.com/testing-library/react-hooks-testing-library.git',
      description: `MIT License

Copyright (c) 2012 Functional Software, Inc. dba Sentry

Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the "Software"), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
of the Software, and to permit persons to whom the Software is furnished to do
so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.`,
    },
    {
      packageName: '@testing-library/react-hooks',
      version: '8.0.1',
      link: 'https://github.com/testing-library/react-hooks-testing-library',
      description: `The MIT License (MIT) Copyright (c) 2019 Michael Peyper

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.`,
    },
    {
      packageName: 'buffer',
      version: '6.0.3',
      link: 'https://github.com/feross/buffer?tab=License-1-ov-file#readme',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) Feross Aboukhadijeh, and other contributors.\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in\n' +
        'all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN\n' +
        'THE SOFTWARE.\n' +
        '\n' +
        'Parts of this software are based on node.js:\n' +
        '\n' +
        'Copyright Node.js contributors. All rights reserved.\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to\n' +
        'deal in the Software without restriction, including without limitation the\n' +
        'rights to use, copy, modify, merge, publish, distribute, sublicense, and/or\n' +
        'sell copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in\n' +
        'all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING\n' +
        'FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS\n' +
        'IN THE SOFTWARE.\n' +
        '\n' +
        'See https://github.com/nodejs/node/blob/main/LICENSE for more information.',
    },
    {
      packageName: 'console-browserify',
      version: '1.2.0',
      link: 'https://github.com/browserify/console-browserify',
      description: `Copyright (c) 2012 Raynos.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.`,
    },
    {
      packageName: 'constants-browserify',
      version: '1.0.0',
      link: 'https://github.com/juliangruber/constants-browserify',
      description: `Copyright (c) 2013 Julian Gruber julian@juliangruber.com

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.`,
    },
    {
      packageName: 'contentful-management',
      version: '11.35.1',
      link: 'https://github.com/contentful/contentful-management.js',
      description: `The MIT License (MIT)

Copyright (c) 2016 Contentful

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.`,
    },
    {
      packageName: 'cookie',
      version: '1.0.1',
      link: 'https://github.com/jshttp/cookie',
      description: `(The MIT License)

Copyright (c) 2012-2014 Roman Shtylman <shtylman@gmail.com>
Copyright (c) 2015 Douglas Christopher Wilson <doug@somethingdoug.com>

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
'Software'), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.`,
    },
    {
      packageName: 'crypto-browserify',
      version: '3.12.0',
      link: 'https://github.com/browserify/crypto-browserify?tab=MIT-1-ov-file#readme',
      description:
        'The MIT License\n' +
        '\n' +
        'Copyright (c) 2013 Dominic Tarr\n' +
        '\n' +
        'Permission is hereby granted, free of charge, \n' +
        'to any person obtaining a copy of this software and \n' +
        'associated documentation files (the "Software"), to \n' +
        'deal in the Software without restriction, including \n' +
        'without limitation the rights to use, copy, modify, \n' +
        'merge, publish, distribute, sublicense, and/or sell \n' +
        'copies of the Software, and to permit persons to whom \n' +
        'the Software is furnished to do so, \n' +
        'subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice \n' +
        'shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, \n' +
        'EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES \n' +
        'OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. \n' +
        'IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR \n' +
        'ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, \n' +
        'TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE \n' +
        'SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'dompurify',
      version: '3.1.7',
      link: 'https://github.com/cure53/DOMPurify',
      description:
        'DOMPurify\n' +
        'Copyright 2025 Dr.-Ing. Mario Heiderich, Cure53\n' +
        '\n' +
        'DOMPurify is free software; you can redistribute it and/or modify it under the\n' +
        'terms of either:\n' +
        '\n' +
        'a) the Apache License Version 2.0, or\n' +
        'b) the Mozilla Public License Version 2.0\n' +
        '\n' +
        '-----------------------------------------------------------------------------\n' +
        '\n' +
        '                                 Apache License\n' +
        '                           Version 2.0, January 2004\n' +
        '                        http://www.apache.org/licenses/\n' +
        '\n' +
        '   TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION\n' +
        '\n' +
        '   1. Definitions.\n' +
        '\n' +
        '      "License" shall mean the terms and conditions for use, reproduction,\n' +
        '      and distribution as defined by Sections 1 through 9 of this document.\n' +
        '\n' +
        '      "Licensor" shall mean the copyright owner or entity authorized by\n' +
        '      the copyright owner that is granting the License.\n' +
        '\n' +
        '      "Legal Entity" shall mean the union of the acting entity and all\n' +
        '      other entities that control, are controlled by, or are under common\n' +
        '      control with that entity. For the purposes of this definition,\n' +
        '      "control" means (i) the power, direct or indirect, to cause the\n' +
        '      direction or management of such entity, whether by contract or\n' +
        '      otherwise, or (ii) ownership of fifty percent (50%) or more of the\n' +
        '      outstanding shares, or (iii) beneficial ownership of such entity.\n' +
        '\n' +
        '      "You" (or "Your") shall mean an individual or Legal Entity\n' +
        '      exercising permissions granted by this License.\n' +
        '\n' +
        '      "Source" form shall mean the preferred form for making modifications,\n' +
        '      including but not limited to software source code, documentation\n' +
        '      source, and configuration files.\n' +
        '\n' +
        '      "Object" form shall mean any form resulting from mechanical\n' +
        '      transformation or translation of a Source form, including but\n' +
        '      not limited to compiled object code, generated documentation,\n' +
        '      and conversions to other media types.\n' +
        '\n' +
        '      "Work" shall mean the work of authorship, whether in Source or\n' +
        '      Object form, made available under the License, as indicated by a\n' +
        '      copyright notice that is included in or attached to the work\n' +
        '      (an example is provided in the Appendix below).\n' +
        '\n' +
        '      "Derivative Works" shall mean any work, whether in Source or Object\n' +
        '      form, that is based on (or derived from) the Work and for which the\n' +
        '      editorial revisions, annotations, elaborations, or other modifications\n' +
        '      represent, as a whole, an original work of authorship. For the purposes\n' +
        '      of this License, Derivative Works shall not include works that remain\n' +
        '      separable from, or merely link (or bind by name) to the interfaces of,\n' +
        '      the Work and Derivative Works thereof.\n' +
        '\n' +
        '      "Contribution" shall mean any work of authorship, including\n' +
        '      the original version of the Work and any modifications or additions\n' +
        '      to that Work or Derivative Works thereof, that is intentionally\n' +
        '      submitted to Licensor for inclusion in the Work by the copyright owner\n' +
        '      or by an individual or Legal Entity authorized to submit on behalf of\n' +
        '      the copyright owner. For the purposes of this definition, "submitted"\n' +
        '      means any form of electronic, verbal, or written communication sent\n' +
        '      to the Licensor or its representatives, including but not limited to\n' +
        '      communication on electronic mailing lists, source code control systems,\n' +
        '      and issue tracking systems that are managed by, or on behalf of, the\n' +
        '      Licensor for the purpose of discussing and improving the Work, but\n' +
        '      excluding communication that is conspicuously marked or otherwise\n' +
        '      designated in writing by the copyright owner as "Not a Contribution."\n' +
        '\n' +
        '      "Contributor" shall mean Licensor and any individual or Legal Entity\n' +
        '      on behalf of whom a Contribution has been received by Licensor and\n' +
        '      subsequently incorporated within the Work.\n' +
        '\n' +
        '   2. Grant of Copyright License. Subject to the terms and conditions of\n' +
        '      this License, each Contributor hereby grants to You a perpetual,\n' +
        '      worldwide, non-exclusive, no-charge, royalty-free, irrevocable\n' +
        '      copyright license to reproduce, prepare Derivative Works of,\n' +
        '      publicly display, publicly perform, sublicense, and distribute the\n' +
        '      Work and such Derivative Works in Source or Object form.\n' +
        '\n' +
        '   3. Grant of Patent License. Subject to the terms and conditions of\n' +
        '      this License, each Contributor hereby grants to You a perpetual,\n' +
        '      worldwide, non-exclusive, no-charge, royalty-free, irrevocable\n' +
        '      (except as stated in this section) patent license to make, have made,\n' +
        '      use, offer to sell, sell, import, and otherwise transfer the Work,\n' +
        '      where such license applies only to those patent claims licensable\n' +
        '      by such Contributor that are necessarily infringed by their\n' +
        '      Contribution(s) alone or by combination of their Contribution(s)\n' +
        '      with the Work to which such Contribution(s) was submitted. If You\n' +
        '      institute patent litigation against any entity (including a\n' +
        '      cross-claim or counterclaim in a lawsuit) alleging that the Work\n' +
        '      or a Contribution incorporated within the Work constitutes direct\n' +
        '      or contributory patent infringement, then any patent licenses\n' +
        '      granted to You under this License for that Work shall terminate\n' +
        '      as of the date such litigation is filed.\n' +
        '\n' +
        '   4. Redistribution. You may reproduce and distribute copies of the\n' +
        '      Work or Derivative Works thereof in any medium, with or without\n' +
        '      modifications, and in Source or Object form, provided that You\n' +
        '      meet the following conditions:\n' +
        '\n' +
        '      (a) You must give any other recipients of the Work or\n' +
        '          Derivative Works a copy of this License; and\n' +
        '\n' +
        '      (b) You must cause any modified files to carry prominent notices\n' +
        '          stating that You changed the files; and\n' +
        '\n' +
        '      (c) You must retain, in the Source form of any Derivative Works\n' +
        '          that You distribute, all copyright, patent, trademark, and\n' +
        '          attribution notices from the Source form of the Work,\n' +
        '          excluding those notices that do not pertain to any part of\n' +
        '          the Derivative Works; and\n' +
        '\n' +
        '      (d) If the Work includes a "NOTICE" text file as part of its\n' +
        '          distribution, then any Derivative Works that You distribute must\n' +
        '          include a readable copy of the attribution notices contained\n' +
        '          within such NOTICE file, excluding those notices that do not\n' +
        '          pertain to any part of the Derivative Works, in at least one\n' +
        '          of the following places: within a NOTICE text file distributed\n' +
        '          as part of the Derivative Works; within the Source form or\n' +
        '          documentation, if provided along with the Derivative Works; or,\n' +
        '          within a display generated by the Derivative Works, if and\n' +
        '          wherever such third-party notices normally appear. The contents\n' +
        '          of the NOTICE file are for informational purposes only and\n' +
        '          do not modify the License. You may add Your own attribution\n' +
        '          notices within Derivative Works that You distribute, alongside\n' +
        '          or as an addendum to the NOTICE text from the Work, provided\n' +
        '          that such additional attribution notices cannot be construed\n' +
        '          as modifying the License.\n' +
        '\n' +
        '      You may add Your own copyright statement to Your modifications and\n' +
        '      may provide additional or different license terms and conditions\n' +
        '      for use, reproduction, or distribution of Your modifications, or\n' +
        '      for any such Derivative Works as a whole, provided Your use,\n' +
        '      reproduction, and distribution of the Work otherwise complies with\n' +
        '      the conditions stated in this License.\n' +
        '\n' +
        '   5. Submission of Contributions. Unless You explicitly state otherwise,\n' +
        '      any Contribution intentionally submitted for inclusion in the Work\n' +
        '      by You to the Licensor shall be under the terms and conditions of\n' +
        '      this License, without any additional terms or conditions.\n' +
        '      Notwithstanding the above, nothing herein shall supersede or modify\n' +
        '      the terms of any separate license agreement you may have executed\n' +
        '      with Licensor regarding such Contributions.\n' +
        '\n' +
        '   6. Trademarks. This License does not grant permission to use the trade\n' +
        '      names, trademarks, service marks, or product names of the Licensor,\n' +
        '      except as required for reasonable and customary use in describing the\n' +
        '      origin of the Work and reproducing the content of the NOTICE file.\n' +
        '\n' +
        '   7. Disclaimer of Warranty. Unless required by applicable law or\n' +
        '      agreed to in writing, Licensor provides the Work (and each\n' +
        '      Contributor provides its Contributions) on an "AS IS" BASIS,\n' +
        '      WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or\n' +
        '      implied, including, without limitation, any warranties or conditions\n' +
        '      of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A\n' +
        '      PARTICULAR PURPOSE. You are solely responsible for determining the\n' +
        '      appropriateness of using or redistributing the Work and assume any\n' +
        '      risks associated with Your exercise of permissions under this License.\n' +
        '\n' +
        '   8. Limitation of Liability. In no event and under no legal theory,\n' +
        '      whether in tort (including negligence), contract, or otherwise,\n' +
        '      unless required by applicable law (such as deliberate and grossly\n' +
        '      negligent acts) or agreed to in writing, shall any Contributor be\n' +
        '      liable to You for damages, including any direct, indirect, special,\n' +
        '      incidental, or consequential damages of any character arising as a\n' +
        '      result of this License or out of the use or inability to use the\n' +
        '      Work (including but not limited to damages for loss of goodwill,\n' +
        '      work stoppage, computer failure or malfunction, or any and all\n' +
        '      other commercial damages or losses), even if such Contributor\n' +
        '      has been advised of the possibility of such damages.\n' +
        '\n' +
        '   9. Accepting Warranty or Additional Liability. While redistributing\n' +
        '      the Work or Derivative Works thereof, You may choose to offer,\n' +
        '      and charge a fee for, acceptance of support, warranty, indemnity,\n' +
        '      or other liability obligations and/or rights consistent with this\n' +
        '      License. However, in accepting such obligations, You may act only\n' +
        '      on Your own behalf and on Your sole responsibility, not on behalf\n' +
        '      of any other Contributor, and only if You agree to indemnify,\n' +
        '      defend, and hold each Contributor harmless for any liability\n' +
        '      incurred by, or claims asserted against, such Contributor by reason\n' +
        '      of your accepting any such warranty or additional liability.\n' +
        '\n' +
        '   END OF TERMS AND CONDITIONS\n' +
        '\n' +
        '   APPENDIX: How to apply the Apache License to your work.\n' +
        '\n' +
        '      To apply the Apache License to your work, attach the following\n' +
        '      boilerplate notice, with the fields enclosed by brackets "[]"\n' +
        "      replaced with your own identifying information. (Don't include\n" +
        '      the brackets!)  The text should be enclosed in the appropriate\n' +
        '      comment syntax for the file format. We also recommend that a\n' +
        '      file or class name and description of purpose be included on the\n' +
        '      same "printed page" as the copyright notice for easier\n' +
        '      identification within third-party archives.\n' +
        '\n' +
        '   Copyright [yyyy] [name of copyright owner]\n' +
        '\n' +
        '   Licensed under the Apache License, Version 2.0 (the "License");\n' +
        '   you may not use this file except in compliance with the License.\n' +
        '   You may obtain a copy of the License at\n' +
        '\n' +
        '       http://www.apache.org/licenses/LICENSE-2.0\n' +
        '\n' +
        '   Unless required by applicable law or agreed to in writing, software\n' +
        '   distributed under the License is distributed on an "AS IS" BASIS,\n' +
        '   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n' +
        '   See the License for the specific language governing permissions and\n' +
        '   limitations under the License.\n',
    },
    {
      packageName: 'dotenv',
      version: '16.3.1',
      link: 'https://github.com/motdotla/dotenv',
      description:
        'Copyright (c) 2015, Scott Motte\n' +
        'All rights reserved.\n' +
        '\n' +
        'Redistribution and use in source and binary forms, with or without\n' +
        'modification, are permitted provided that the following conditions are met:\n' +
        '\n' +
        '* Redistributions of source code must retain the above copyright notice, this\n' +
        '  list of conditions and the following disclaimer.\n' +
        '\n' +
        '* Redistributions in binary form must reproduce the above copyright notice,\n' +
        '  this list of conditions and the following disclaimer in the documentation\n' +
        '  and/or other materials provided with the distribution.\n' +
        '\n' +
        'THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"\n' +
        'AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE\n' +
        'IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE\n' +
        'DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE\n' +
        'FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL\n' +
        'DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR\n' +
        'SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER\n' +
        'CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,\n' +
        'OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE\n' +
        'OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.',
    },
    {
      packageName: 'graphql',
      version: '16.8.1',
      link: 'https://github.com/graphql/graphql-js',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) GraphQL Contributors\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'html2pdf.js',
      version: '0.10.2',
      link: 'https://github.com/eKoopmans/html2pdf.js',
      description:
        'The MIT License\n' +
        '\n' +
        'Copyright (c) 2017 Erik Koopmans\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in\n' +
        'all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'https-browserify',
      version: '1.0.0',
      link: 'https://github.com/browserify/browserify?tab=MIT-1-ov-file#readme',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) 2010 James Halliday\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'lodash.shuffle',
      version: '4.2.0',
      link: 'https://github.com/lodash/lodash',
      description:
        'Copyright OpenJS Foundation and other contributors <https://openjsf.org/>\n' +
        '\n' +
        'Based on Underscore.js, copyright Jeremy Ashkenas,\n' +
        'DocumentCloud and Investigative Reporters & Editors <http://underscorejs.org/>\n' +
        '\n' +
        'This software consists of voluntary contributions made by many\n' +
        'individuals. For exact contribution history, see the revision history\n' +
        'available at https://github.com/lodash/lodash\n' +
        '\n' +
        'The following license applies to all parts of this software except as\n' +
        'documented below:\n' +
        '\n' +
        '====\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining\n' +
        'a copy of this software and associated documentation files (the\n' +
        '"Software"), to deal in the Software without restriction, including\n' +
        'without limitation the rights to use, copy, modify, merge, publish,\n' +
        'distribute, sublicense, and/or sell copies of the Software, and to\n' +
        'permit persons to whom the Software is furnished to do so, subject to\n' +
        'the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be\n' +
        'included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,\n' +
        'EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF\n' +
        'MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND\n' +
        'NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE\n' +
        'LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION\n' +
        'OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION\n' +
        'WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.\n' +
        '\n' +
        '====\n' +
        '\n' +
        'Copyright and related rights for sample code are waived via CC0. Sample\n' +
        'code is defined as all source code displayed within the prose of the\n' +
        'documentation.\n' +
        '\n' +
        'CC0: http://creativecommons.org/publicdomain/zero/1.0/\n' +
        '\n' +
        '====\n' +
        '\n' +
        'Files located in the node_modules and vendor directories are externally\n' +
        'maintained libraries used by this software which have their own\n' +
        'licenses; we recommend you read them, as their terms may differ from the\n' +
        'terms above.',
    },
    {
      packageName: 'os-browserify',
      version: '0.3.0',
      link: 'https://github.com/CoderPuppy/os-browserify',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2017 CoderPuppy\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'path-browserify',
      version: '1.0.1',
      link: 'https://github.com/browserify/path-browserify',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) 2013 James Halliday\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of\n' +
        'this software and associated documentation files (the "Software"), to deal in\n' +
        'the Software without restriction, including without limitation the rights to\n' +
        'use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of\n' +
        'the Software, and to permit persons to whom the Software is furnished to do so,\n' +
        'subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS\n' +
        'FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR\n' +
        'COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER\n' +
        'IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN\n' +
        'CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'plyr',
      version: '3.7.8',
      link: 'https://github.com/sampotts/plyr',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2017 Sam Potts\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'process',
      version: '0.11.10',
      link: 'https://github.com/shtylman/node-process',
      description:
        '(The MIT License)\n' +
        '\n' +
        'Copyright (c) 2013 Roman Shtylman <shtylman@gmail.com>\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining\n' +
        'a copy of this software and associated documentation files (the\n' +
        "'Software'), to deal in the Software without restriction, including\n" +
        'without limitation the rights to use, copy, modify, merge, publish,\n' +
        'distribute, sublicense, and/or sell copies of the Software, and to\n' +
        'permit persons to whom the Software is furnished to do so, subject to\n' +
        'the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be\n' +
        'included in all copies or substantial portions of the Software.\n' +
        '\n' +
        "THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,\n" +
        'EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF\n' +
        'MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.\n' +
        'IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY\n' +
        'CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,\n' +
        'TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE\n' +
        'SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'querystring-es3',
      version: '0.2.1',
      link: 'https://github.com/mike-spainhower/querystring',
      description:
        'Copyright 2012 Irakli Gozalishvili. All rights reserved. Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'queue-microtask',
      version: '1.2.3',
      link: 'https://github.com/feross/queue-microtask',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) Feross Aboukhadijeh\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of\n' +
        'this software and associated documentation files (the "Software"), to deal in\n' +
        'the Software without restriction, including without limitation the rights to\n' +
        'use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of\n' +
        'the Software, and to permit persons to whom the Software is furnished to do so,\n' +
        'subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS\n' +
        'FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR\n' +
        'COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER\n' +
        'IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN\n' +
        'CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'react',
      version: '18.2.0',
      link: 'https://github.com/facebook/react',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) Meta Platforms, Inc. and affiliates.\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'react-dom',
      version: '18.2.0',
      link: 'https://github.com/facebook/react',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) Meta Platforms, Inc. and affiliates.\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'react-markdown',
      version: '9.0.1',
      link: 'https://github.com/remarkjs/react-markdown',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) Espen Hovlandsdal\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'react-router-dom',
      version: '6.20.0',
      link: 'https://github.com/remix-run/react-router',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) React Training LLC 2015-2019 Copyright (c) Remix Software Inc. 2020-2021 Copyright (c) Shopify Inc. 2022-2023\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'rehype-raw',
      version: '7.0.0',
      link: 'https://github.com/rehypejs/rehype-raw',
      description:
        '(The MIT License)\n' +
        '\n' +
        'Copyright (c) Titus Wormer <tituswormer@gmail.com>\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining\n' +
        'a copy of this software and associated documentation files (the\n' +
        "'Software'), to deal in the Software without restriction, including\n" +
        'without limitation the rights to use, copy, modify, merge, publish,\n' +
        'distribute, sublicense, and/or sell copies of the Software, and to\n' +
        'permit persons to whom the Software is furnished to do so, subject to\n' +
        'the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be\n' +
        'included in all copies or substantial portions of the Software.\n' +
        '\n' +
        "THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,\n" +
        'EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF\n' +
        'MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.\n' +
        'IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY\n' +
        'CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,\n' +
        'TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE\n' +
        'SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'remark-breaks',
      version: '4.0.0',
      link: 'https://github.com/remarkjs/remark-breaks',
      description:
        '(The MIT License)\n' +
        '\n' +
        'Copyright (c) 2017 Titus Wormer <tituswormer@gmail.com>\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining\n' +
        'a copy of this software and associated documentation files (the\n' +
        "'Software'), to deal in the Software without restriction, including\n" +
        'without limitation the rights to use, copy, modify, merge, publish,\n' +
        'distribute, sublicense, and/or sell copies of the Software, and to\n' +
        'permit persons to whom the Software is furnished to do so, subject to\n' +
        'the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be\n' +
        'included in all copies or substantial portions of the Software.\n' +
        '\n' +
        "THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,\n" +
        'EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF\n' +
        'MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.\n' +
        'IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY\n' +
        'CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,\n' +
        'TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE\n' +
        'SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'remark-gfm',
      version: '4.0.0',
      link: 'https://github.com/remarkjs/remark-gfm',
      description:
        '(The MIT License)\n' +
        '\n' +
        'Copyright (c) Titus Wormer <tituswormer@gmail.com>\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining\n' +
        'a copy of this software and associated documentation files (the\n' +
        "'Software'), to deal in the Software without restriction, including\n" +
        'without limitation the rights to use, copy, modify, merge, publish,\n' +
        'distribute, sublicense, and/or sell copies of the Software, and to\n' +
        'permit persons to whom the Software is furnished to do so, subject to\n' +
        'the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be\n' +
        'included in all copies or substantial portions of the Software.\n' +
        '\n' +
        "THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,\n" +
        'EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF\n' +
        'MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.\n' +
        'IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY\n' +
        'CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,\n' +
        'TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE\n' +
        'SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'stream-http',
      version: '3.2.0',
      link: 'https://github.com/jhiesey/stream-http',
      description:
        'The MIT License\n' +
        '\n' +
        'Copyright (c) 2015 John Hiesey\n' +
        '\n' +
        'Permission is hereby granted, free of charge, \n' +
        'to any person obtaining a copy of this software and \n' +
        'associated documentation files (the "Software"), to \n' +
        'deal in the Software without restriction, including \n' +
        'without limitation the rights to use, copy, modify, \n' +
        'merge, publish, distribute, sublicense, and/or sell \n' +
        'copies of the Software, and to permit persons to whom \n' +
        'the Software is furnished to do so, \n' +
        'subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice \n' +
        'shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, \n' +
        'EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES \n' +
        'OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. \n' +
        'IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR \n' +
        'ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, \n' +
        'TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE \n' +
        'SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'tty-browserify',
      version: '0.0.1',
      link: 'https://github.com/browserify/tty-browserify',
      description:
        'MIT License\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of\n' +
        'this software and associated documentation files (the "Software"), to deal in\n' +
        'the Software without restriction, including without limitation the rights to\n' +
        'use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of\n' +
        'the Software, and to permit persons to whom the Software is furnished to do so,\n' +
        'subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS\n' +
        'FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR\n' +
        'COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER\n' +
        'IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN\n' +
        'CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'whatwg-fetch',
      version: '3.6.19',
      link: 'https://github.com/github/fetch',
      description:
        'Copyright (c) 2014-2023 GitHub, Inc.\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining\n' +
        'a copy of this software and associated documentation files (the\n' +
        '"Software"), to deal in the Software without restriction, including\n' +
        'without limitation the rights to use, copy, modify, merge, publish,\n' +
        'distribute, sublicense, and/or sell copies of the Software, and to\n' +
        'permit persons to whom the Software is furnished to do so, subject to\n' +
        'the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be\n' +
        'included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,\n' +
        'EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF\n' +
        'MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND\n' +
        'NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE\n' +
        'LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION\n' +
        'OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION\n' +
        'WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: '@babel/core',
      version: '7.24.4',
      link: 'https://github.com/babel/babel',
      description: `MIT License

Copyright (c) 2014-present Sebastian McKenzie and other contributors

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.`,
    },
    {
      packageName: '@babel/preset-env',
      version: '7.24.4',
      link: 'https://github.com/babel/babel',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) 2014-present Sebastian McKenzie and other contributors\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining\n' +
        'a copy of this software and associated documentation files (the\n' +
        '"Software"), to deal in the Software without restriction, including\n' +
        'without limitation the rights to use, copy, modify, merge, publish,\n' +
        'distribute, sublicense, and/or sell copies of the Software, and to\n' +
        'permit persons to whom the Software is furnished to do so, subject to\n' +
        'the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be\n' +
        'included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,\n' +
        'EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF\n' +
        'MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND\n' +
        'NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE\n' +
        'LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION\n' +
        'OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION\n' +
        'WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: '@babel/preset-react',
      version: '7.24.1',
      link: 'https://github.com/babel/babel',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) 2014-present Sebastian McKenzie and other contributors\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining\n' +
        'a copy of this software and associated documentation files (the\n' +
        '"Software"), to deal in the Software without restriction, including\n' +
        'without limitation the rights to use, copy, modify, merge, publish,\n' +
        'distribute, sublicense, and/or sell copies of the Software, and to\n' +
        'permit persons to whom the Software is furnished to do so, subject to\n' +
        'the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be\n' +
        'included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,\n' +
        'EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF\n' +
        'MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND\n' +
        'NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE\n' +
        'LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION\n' +
        'OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION\n' +
        'WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: '@babel/preset-typescript',
      version: '7.24.1',
      link: 'https://github.com/babel/babel',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) 2014-present Sebastian McKenzie and other contributors\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining\n' +
        'a copy of this software and associated documentation files (the\n' +
        '"Software"), to deal in the Software without restriction, including\n' +
        'without limitation the rights to use, copy, modify, merge, publish,\n' +
        'distribute, sublicense, and/or sell copies of the Software, and to\n' +
        'permit persons to whom the Software is furnished to do so, subject to\n' +
        'the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be\n' +
        'included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,\n' +
        'EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF\n' +
        'MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND\n' +
        'NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE\n' +
        'LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION\n' +
        'OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION\n' +
        'WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: '@compiled/babel-plugin',
      version: '0.28.4',
      link: 'https://github.com/atlassian-labs/compiled',
      description:
        '                                 Apache License\n' +
        '                           Version 2.0, January 2004\n' +
        '                        http://www.apache.org/licenses/\n' +
        '\n' +
        '   TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION\n' +
        '\n' +
        '   1. Definitions.\n' +
        '\n' +
        '      "License" shall mean the terms and conditions for use, reproduction,\n' +
        '      and distribution as defined by Sections 1 through 9 of this document.\n' +
        '\n' +
        '      "Licensor" shall mean the copyright owner or entity authorized by\n' +
        '      the copyright owner that is granting the License.\n' +
        '\n' +
        '      "Legal Entity" shall mean the union of the acting entity and all\n' +
        '      other entities that control, are controlled by, or are under common\n' +
        '      control with that entity. For the purposes of this definition,\n' +
        '      "control" means (i) the power, direct or indirect, to cause the\n' +
        '      direction or management of such entity, whether by contract or\n' +
        '      otherwise, or (ii) ownership of fifty percent (50%) or more of the\n' +
        '      outstanding shares, or (iii) beneficial ownership of such entity.\n' +
        '\n' +
        '      "You" (or "Your") shall mean an individual or Legal Entity\n' +
        '      exercising permissions granted by this License.\n' +
        '\n' +
        '      "Source" form shall mean the preferred form for making modifications,\n' +
        '      including but not limited to software source code, documentation\n' +
        '      source, and configuration files.\n' +
        '\n' +
        '      "Object" form shall mean any form resulting from mechanical\n' +
        '      transformation or translation of a Source form, including but\n' +
        '      not limited to compiled object code, generated documentation,\n' +
        '      and conversions to other media types.\n' +
        '\n' +
        '      "Work" shall mean the work of authorship, whether in Source or\n' +
        '      Object form, made available under the License, as indicated by a\n' +
        '      copyright notice that is included in or attached to the work\n' +
        '      (an example is provided in the Appendix below).\n' +
        '\n' +
        '      "Derivative Works" shall mean any work, whether in Source or Object\n' +
        '      form, that is based on (or derived from) the Work and for which the\n' +
        '      editorial revisions, annotations, elaborations, or other modifications\n' +
        '      represent, as a whole, an original work of authorship. For the purposes\n' +
        '      of this License, Derivative Works shall not include works that remain\n' +
        '      separable from, or merely link (or bind by name) to the interfaces of,\n' +
        '      the Work and Derivative Works thereof.\n' +
        '\n' +
        '      "Contribution" shall mean any work of authorship, including\n' +
        '      the original version of the Work and any modifications or additions\n' +
        '      to that Work or Derivative Works thereof, that is intentionally\n' +
        '      submitted to Licensor for inclusion in the Work by the copyright owner\n' +
        '      or by an individual or Legal Entity authorized to submit on behalf of\n' +
        '      the copyright owner. For the purposes of this definition, "submitted"\n' +
        '      means any form of electronic, verbal, or written communication sent\n' +
        '      to the Licensor or its representatives, including but not limited to\n' +
        '      communication on electronic mailing lists, source code control systems,\n' +
        '      and issue tracking systems that are managed by, or on behalf of, the\n' +
        '      Licensor for the purpose of discussing and improving the Work, but\n' +
        '      excluding communication that is conspicuously marked or otherwise\n' +
        '      designated in writing by the copyright owner as "Not a Contribution."\n' +
        '\n' +
        '      "Contributor" shall mean Licensor and any individual or Legal Entity\n' +
        '      on behalf of whom a Contribution has been received by Licensor and\n' +
        '      subsequently incorporated within the Work.\n' +
        '\n' +
        '   2. Grant of Copyright License. Subject to the terms and conditions of\n' +
        '      this License, each Contributor hereby grants to You a perpetual,\n' +
        '      worldwide, non-exclusive, no-charge, royalty-free, irrevocable\n' +
        '      copyright license to reproduce, prepare Derivative Works of,\n' +
        '      publicly display, publicly perform, sublicense, and distribute the\n' +
        '      Work and such Derivative Works in Source or Object form.\n' +
        '\n' +
        '   3. Grant of Patent License. Subject to the terms and conditions of\n' +
        '      this License, each Contributor hereby grants to You a perpetual,\n' +
        '      worldwide, non-exclusive, no-charge, royalty-free, irrevocable\n' +
        '      (except as stated in this section) patent license to make, have made,\n' +
        '      use, offer to sell, sell, import, and otherwise transfer the Work,\n' +
        '      where such license applies only to those patent claims licensable\n' +
        '      by such Contributor that are necessarily infringed by their\n' +
        '      Contribution(s) alone or by combination of their Contribution(s)\n' +
        '      with the Work to which such Contribution(s) was submitted. If You\n' +
        '      institute patent litigation against any entity (including a\n' +
        '      cross-claim or counterclaim in a lawsuit) alleging that the Work\n' +
        '      or a Contribution incorporated within the Work constitutes direct\n' +
        '      or contributory patent infringement, then any patent licenses\n' +
        '      granted to You under this License for that Work shall terminate\n' +
        '      as of the date such litigation is filed.\n' +
        '\n' +
        '   4. Redistribution. You may reproduce and distribute copies of the\n' +
        '      Work or Derivative Works thereof in any medium, with or without\n' +
        '      modifications, and in Source or Object form, provided that You\n' +
        '      meet the following conditions:\n' +
        '\n' +
        '      (a) You must give any other recipients of the Work or\n' +
        '          Derivative Works a copy of this License; and\n' +
        '\n' +
        '      (b) You must cause any modified files to carry prominent notices\n' +
        '          stating that You changed the files; and\n' +
        '\n' +
        '      (c) You must retain, in the Source form of any Derivative Works\n' +
        '          that You distribute, all copyright, patent, trademark, and\n' +
        '          attribution notices from the Source form of the Work,\n' +
        '          excluding those notices that do not pertain to any part of\n' +
        '          the Derivative Works; and\n' +
        '\n' +
        '      (d) If the Work includes a "NOTICE" text file as part of its\n' +
        '          distribution, then any Derivative Works that You distribute must\n' +
        '          include a readable copy of the attribution notices contained\n' +
        '          within such NOTICE file, excluding those notices that do not\n' +
        '          pertain to any part of the Derivative Works, in at least one\n' +
        '          of the following places: within a NOTICE text file distributed\n' +
        '          as part of the Derivative Works; within the Source form or\n' +
        '          documentation, if provided along with the Derivative Works; or,\n' +
        '          within a display generated by the Derivative Works, if and\n' +
        '          wherever such third-party notices normally appear. The contents\n' +
        '          of the NOTICE file are for informational purposes only and\n' +
        '          do not modify the License. You may add Your own attribution\n' +
        '          notices within Derivative Works that You distribute, alongside\n' +
        '          or as an addendum to the NOTICE text from the Work, provided\n' +
        '          that such additional attribution notices cannot be construed\n' +
        '          as modifying the License.\n' +
        '\n' +
        '      You may add Your own copyright statement to Your modifications and\n' +
        '      may provide additional or different license terms and conditions\n' +
        '      for use, reproduction, or distribution of Your modifications, or\n' +
        '      for any such Derivative Works as a whole, provided Your use,\n' +
        '      reproduction, and distribution of the Work otherwise complies with\n' +
        '      the conditions stated in this License.\n' +
        '\n' +
        '   5. Submission of Contributions. Unless You explicitly state otherwise,\n' +
        '      any Contribution intentionally submitted for inclusion in the Work\n' +
        '      by You to the Licensor shall be under the terms and conditions of\n' +
        '      this License, without any additional terms or conditions.\n' +
        '      Notwithstanding the above, nothing herein shall supersede or modify\n' +
        '      the terms of any separate license agreement you may have executed\n' +
        '      with Licensor regarding such Contributions.\n' +
        '\n' +
        '   6. Trademarks. This License does not grant permission to use the trade\n' +
        '      names, trademarks, service marks, or product names of the Licensor,\n' +
        '      except as required for reasonable and customary use in describing the\n' +
        '      origin of the Work and reproducing the content of the NOTICE file.\n' +
        '\n' +
        '   7. Disclaimer of Warranty. Unless required by applicable law or\n' +
        '      agreed to in writing, Licensor provides the Work (and each\n' +
        '      Contributor provides its Contributions) on an "AS IS" BASIS,\n' +
        '      WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or\n' +
        '      implied, including, without limitation, any warranties or conditions\n' +
        '      of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A\n' +
        '      PARTICULAR PURPOSE. You are solely responsible for determining the\n' +
        '      appropriateness of using or redistributing the Work and assume any\n' +
        '      risks associated with Your exercise of permissions under this License.\n' +
        '\n' +
        '   8. Limitation of Liability. In no event and under no legal theory,\n' +
        '      whether in tort (including negligence), contract, or otherwise,\n' +
        '      unless required by applicable law (such as deliberate and grossly\n' +
        '      negligent acts) or agreed to in writing, shall any Contributor be\n' +
        '      liable to You for damages, including any direct, indirect, special,\n' +
        '      incidental, or consequential damages of any character arising as a\n' +
        '      result of this License or out of the use or inability to use the\n' +
        '      Work (including but not limited to damages for loss of goodwill,\n' +
        '      work stoppage, computer failure or malfunction, or any and all\n' +
        '      other commercial damages or losses), even if such Contributor\n' +
        '      has been advised of the possibility of such damages.\n' +
        '\n' +
        '   9. Accepting Warranty or Additional Liability. While redistributing\n' +
        '      the Work or Derivative Works thereof, You may choose to offer,\n' +
        '      and charge a fee for, acceptance of support, warranty, indemnity,\n' +
        '      or other liability obligations and/or rights consistent with this\n' +
        '      License. However, in accepting such obligations, You may act only\n' +
        '      on Your own behalf and on Your sole responsibility, not on behalf\n' +
        '      of any other Contributor, and only if You agree to indemnify,\n' +
        '      defend, and hold each Contributor harmless for any liability\n' +
        '      incurred by, or claims asserted against, such Contributor by reason\n' +
        '      of your accepting any such warranty or additional liability.\n' +
        '\n' +
        '   END OF TERMS AND CONDITIONS\n' +
        '\n' +
        '   APPENDIX: How to apply the Apache License to your work.\n' +
        '\n' +
        '      To apply the Apache License to your work, attach the following\n' +
        '      boilerplate notice, with the fields enclosed by brackets "[]"\n' +
        "      replaced with your own identifying information. (Don't include\n" +
        '      the brackets!)  The text should be enclosed in the appropriate\n' +
        '      comment syntax for the file format. We also recommend that a\n' +
        '      file or class name and description of purpose be included on the\n' +
        '      same "printed page" as the copyright notice for easier\n' +
        '      identification within third-party archives.\n' +
        '\n' +
        '   Copyright 2019-Present Atlassian Pty Ltd\n' +
        '\n' +
        '   Licensed under the Apache License, Version 2.0 (the "License");\n' +
        '   you may not use this file except in compliance with the License.\n' +
        '   You may obtain a copy of the License at\n' +
        '\n' +
        '       http://www.apache.org/licenses/LICENSE-2.0\n' +
        '\n' +
        '   Unless required by applicable law or agreed to in writing, software\n' +
        '   distributed under the License is distributed on an "AS IS" BASIS,\n' +
        '   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n' +
        '   See the License for the specific language governing permissions and\n' +
        '   limitations under the License.',
    },
    {
      packageName: '@compiled/jest',
      version: '0.10.1',
      link: 'https://github.com/atlassian-labs/compiled',
      description:
        '                                 Apache License\n' +
        '                           Version 2.0, January 2004\n' +
        '                        http://www.apache.org/licenses/\n' +
        '\n' +
        '   TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION\n' +
        '\n' +
        '   1. Definitions.\n' +
        '\n' +
        '      "License" shall mean the terms and conditions for use, reproduction,\n' +
        '      and distribution as defined by Sections 1 through 9 of this document.\n' +
        '\n' +
        '      "Licensor" shall mean the copyright owner or entity authorized by\n' +
        '      the copyright owner that is granting the License.\n' +
        '\n' +
        '      "Legal Entity" shall mean the union of the acting entity and all\n' +
        '      other entities that control, are controlled by, or are under common\n' +
        '      control with that entity. For the purposes of this definition,\n' +
        '      "control" means (i) the power, direct or indirect, to cause the\n' +
        '      direction or management of such entity, whether by contract or\n' +
        '      otherwise, or (ii) ownership of fifty percent (50%) or more of the\n' +
        '      outstanding shares, or (iii) beneficial ownership of such entity.\n' +
        '\n' +
        '      "You" (or "Your") shall mean an individual or Legal Entity\n' +
        '      exercising permissions granted by this License.\n' +
        '\n' +
        '      "Source" form shall mean the preferred form for making modifications,\n' +
        '      including but not limited to software source code, documentation\n' +
        '      source, and configuration files.\n' +
        '\n' +
        '      "Object" form shall mean any form resulting from mechanical\n' +
        '      transformation or translation of a Source form, including but\n' +
        '      not limited to compiled object code, generated documentation,\n' +
        '      and conversions to other media types.\n' +
        '\n' +
        '      "Work" shall mean the work of authorship, whether in Source or\n' +
        '      Object form, made available under the License, as indicated by a\n' +
        '      copyright notice that is included in or attached to the work\n' +
        '      (an example is provided in the Appendix below).\n' +
        '\n' +
        '      "Derivative Works" shall mean any work, whether in Source or Object\n' +
        '      form, that is based on (or derived from) the Work and for which the\n' +
        '      editorial revisions, annotations, elaborations, or other modifications\n' +
        '      represent, as a whole, an original work of authorship. For the purposes\n' +
        '      of this License, Derivative Works shall not include works that remain\n' +
        '      separable from, or merely link (or bind by name) to the interfaces of,\n' +
        '      the Work and Derivative Works thereof.\n' +
        '\n' +
        '      "Contribution" shall mean any work of authorship, including\n' +
        '      the original version of the Work and any modifications or additions\n' +
        '      to that Work or Derivative Works thereof, that is intentionally\n' +
        '      submitted to Licensor for inclusion in the Work by the copyright owner\n' +
        '      or by an individual or Legal Entity authorized to submit on behalf of\n' +
        '      the copyright owner. For the purposes of this definition, "submitted"\n' +
        '      means any form of electronic, verbal, or written communication sent\n' +
        '      to the Licensor or its representatives, including but not limited to\n' +
        '      communication on electronic mailing lists, source code control systems,\n' +
        '      and issue tracking systems that are managed by, or on behalf of, the\n' +
        '      Licensor for the purpose of discussing and improving the Work, but\n' +
        '      excluding communication that is conspicuously marked or otherwise\n' +
        '      designated in writing by the copyright owner as "Not a Contribution."\n' +
        '\n' +
        '      "Contributor" shall mean Licensor and any individual or Legal Entity\n' +
        '      on behalf of whom a Contribution has been received by Licensor and\n' +
        '      subsequently incorporated within the Work.\n' +
        '\n' +
        '   2. Grant of Copyright License. Subject to the terms and conditions of\n' +
        '      this License, each Contributor hereby grants to You a perpetual,\n' +
        '      worldwide, non-exclusive, no-charge, royalty-free, irrevocable\n' +
        '      copyright license to reproduce, prepare Derivative Works of,\n' +
        '      publicly display, publicly perform, sublicense, and distribute the\n' +
        '      Work and such Derivative Works in Source or Object form.\n' +
        '\n' +
        '   3. Grant of Patent License. Subject to the terms and conditions of\n' +
        '      this License, each Contributor hereby grants to You a perpetual,\n' +
        '      worldwide, non-exclusive, no-charge, royalty-free, irrevocable\n' +
        '      (except as stated in this section) patent license to make, have made,\n' +
        '      use, offer to sell, sell, import, and otherwise transfer the Work,\n' +
        '      where such license applies only to those patent claims licensable\n' +
        '      by such Contributor that are necessarily infringed by their\n' +
        '      Contribution(s) alone or by combination of their Contribution(s)\n' +
        '      with the Work to which such Contribution(s) was submitted. If You\n' +
        '      institute patent litigation against any entity (including a\n' +
        '      cross-claim or counterclaim in a lawsuit) alleging that the Work\n' +
        '      or a Contribution incorporated within the Work constitutes direct\n' +
        '      or contributory patent infringement, then any patent licenses\n' +
        '      granted to You under this License for that Work shall terminate\n' +
        '      as of the date such litigation is filed.\n' +
        '\n' +
        '   4. Redistribution. You may reproduce and distribute copies of the\n' +
        '      Work or Derivative Works thereof in any medium, with or without\n' +
        '      modifications, and in Source or Object form, provided that You\n' +
        '      meet the following conditions:\n' +
        '\n' +
        '      (a) You must give any other recipients of the Work or\n' +
        '          Derivative Works a copy of this License; and\n' +
        '\n' +
        '      (b) You must cause any modified files to carry prominent notices\n' +
        '          stating that You changed the files; and\n' +
        '\n' +
        '      (c) You must retain, in the Source form of any Derivative Works\n' +
        '          that You distribute, all copyright, patent, trademark, and\n' +
        '          attribution notices from the Source form of the Work,\n' +
        '          excluding those notices that do not pertain to any part of\n' +
        '          the Derivative Works; and\n' +
        '\n' +
        '      (d) If the Work includes a "NOTICE" text file as part of its\n' +
        '          distribution, then any Derivative Works that You distribute must\n' +
        '          include a readable copy of the attribution notices contained\n' +
        '          within such NOTICE file, excluding those notices that do not\n' +
        '          pertain to any part of the Derivative Works, in at least one\n' +
        '          of the following places: within a NOTICE text file distributed\n' +
        '          as part of the Derivative Works; within the Source form or\n' +
        '          documentation, if provided along with the Derivative Works; or,\n' +
        '          within a display generated by the Derivative Works, if and\n' +
        '          wherever such third-party notices normally appear. The contents\n' +
        '          of the NOTICE file are for informational purposes only and\n' +
        '          do not modify the License. You may add Your own attribution\n' +
        '          notices within Derivative Works that You distribute, alongside\n' +
        '          or as an addendum to the NOTICE text from the Work, provided\n' +
        '          that such additional attribution notices cannot be construed\n' +
        '          as modifying the License.\n' +
        '\n' +
        '      You may add Your own copyright statement to Your modifications and\n' +
        '      may provide additional or different license terms and conditions\n' +
        '      for use, reproduction, or distribution of Your modifications, or\n' +
        '      for any such Derivative Works as a whole, provided Your use,\n' +
        '      reproduction, and distribution of the Work otherwise complies with\n' +
        '      the conditions stated in this License.\n' +
        '\n' +
        '   5. Submission of Contributions. Unless You explicitly state otherwise,\n' +
        '      any Contribution intentionally submitted for inclusion in the Work\n' +
        '      by You to the Licensor shall be under the terms and conditions of\n' +
        '      this License, without any additional terms or conditions.\n' +
        '      Notwithstanding the above, nothing herein shall supersede or modify\n' +
        '      the terms of any separate license agreement you may have executed\n' +
        '      with Licensor regarding such Contributions.\n' +
        '\n' +
        '   6. Trademarks. This License does not grant permission to use the trade\n' +
        '      names, trademarks, service marks, or product names of the Licensor,\n' +
        '      except as required for reasonable and customary use in describing the\n' +
        '      origin of the Work and reproducing the content of the NOTICE file.\n' +
        '\n' +
        '   7. Disclaimer of Warranty. Unless required by applicable law or\n' +
        '      agreed to in writing, Licensor provides the Work (and each\n' +
        '      Contributor provides its Contributions) on an "AS IS" BASIS,\n' +
        '      WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or\n' +
        '      implied, including, without limitation, any warranties or conditions\n' +
        '      of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A\n' +
        '      PARTICULAR PURPOSE. You are solely responsible for determining the\n' +
        '      appropriateness of using or redistributing the Work and assume any\n' +
        '      risks associated with Your exercise of permissions under this License.\n' +
        '\n' +
        '   8. Limitation of Liability. In no event and under no legal theory,\n' +
        '      whether in tort (including negligence), contract, or otherwise,\n' +
        '      unless required by applicable law (such as deliberate and grossly\n' +
        '      negligent acts) or agreed to in writing, shall any Contributor be\n' +
        '      liable to You for damages, including any direct, indirect, special,\n' +
        '      incidental, or consequential damages of any character arising as a\n' +
        '      result of this License or out of the use or inability to use the\n' +
        '      Work (including but not limited to damages for loss of goodwill,\n' +
        '      work stoppage, computer failure or malfunction, or any and all\n' +
        '      other commercial damages or losses), even if such Contributor\n' +
        '      has been advised of the possibility of such damages.\n' +
        '\n' +
        '   9. Accepting Warranty or Additional Liability. While redistributing\n' +
        '      the Work or Derivative Works thereof, You may choose to offer,\n' +
        '      and charge a fee for, acceptance of support, warranty, indemnity,\n' +
        '      or other liability obligations and/or rights consistent with this\n' +
        '      License. However, in accepting such obligations, You may act only\n' +
        '      on Your own behalf and on Your sole responsibility, not on behalf\n' +
        '      of any other Contributor, and only if You agree to indemnify,\n' +
        '      defend, and hold each Contributor harmless for any liability\n' +
        '      incurred by, or claims asserted against, such Contributor by reason\n' +
        '      of your accepting any such warranty or additional liability.\n' +
        '\n' +
        '   END OF TERMS AND CONDITIONS\n' +
        '\n' +
        '   APPENDIX: How to apply the Apache License to your work.\n' +
        '\n' +
        '      To apply the Apache License to your work, attach the following\n' +
        '      boilerplate notice, with the fields enclosed by brackets "[]"\n' +
        "      replaced with your own identifying information. (Don't include\n" +
        '      the brackets!)  The text should be enclosed in the appropriate\n' +
        '      comment syntax for the file format. We also recommend that a\n' +
        '      file or class name and description of purpose be included on the\n' +
        '      same "printed page" as the copyright notice for easier\n' +
        '      identification within third-party archives.\n' +
        '\n' +
        '   Copyright 2019-Present Atlassian Pty Ltd\n' +
        '\n' +
        '   Licensed under the Apache License, Version 2.0 (the "License");\n' +
        '   you may not use this file except in compliance with the License.\n' +
        '   You may obtain a copy of the License at\n' +
        '\n' +
        '       http://www.apache.org/licenses/LICENSE-2.0\n' +
        '\n' +
        '   Unless required by applicable law or agreed to in writing, software\n' +
        '   distributed under the License is distributed on an "AS IS" BASIS,\n' +
        '   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n' +
        '   See the License for the specific language governing permissions and\n' +
        '   limitations under the License.',
    },
    {
      packageName: '@compiled/webpack-loader',
      version: '0.12.5',
      link: 'https://github.com/atlassian-labs/compiled',
      description:
        '                               Apache License\n' +
        '                           Version 2.0, January 2004\n' +
        '                        http://www.apache.org/licenses/\n' +
        '\n' +
        '   TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION\n' +
        '\n' +
        '   1. Definitions.\n' +
        '\n' +
        '      "License" shall mean the terms and conditions for use, reproduction,\n' +
        '      and distribution as defined by Sections 1 through 9 of this document.\n' +
        '\n' +
        '      "Licensor" shall mean the copyright owner or entity authorized by\n' +
        '      the copyright owner that is granting the License.\n' +
        '\n' +
        '      "Legal Entity" shall mean the union of the acting entity and all\n' +
        '      other entities that control, are controlled by, or are under common\n' +
        '      control with that entity. For the purposes of this definition,\n' +
        '      "control" means (i) the power, direct or indirect, to cause the\n' +
        '      direction or management of such entity, whether by contract or\n' +
        '      otherwise, or (ii) ownership of fifty percent (50%) or more of the\n' +
        '      outstanding shares, or (iii) beneficial ownership of such entity.\n' +
        '\n' +
        '      "You" (or "Your") shall mean an individual or Legal Entity\n' +
        '      exercising permissions granted by this License.\n' +
        '\n' +
        '      "Source" form shall mean the preferred form for making modifications,\n' +
        '      including but not limited to software source code, documentation\n' +
        '      source, and configuration files.\n' +
        '\n' +
        '      "Object" form shall mean any form resulting from mechanical\n' +
        '      transformation or translation of a Source form, including but\n' +
        '      not limited to compiled object code, generated documentation,\n' +
        '      and conversions to other media types.\n' +
        '\n' +
        '      "Work" shall mean the work of authorship, whether in Source or\n' +
        '      Object form, made available under the License, as indicated by a\n' +
        '      copyright notice that is included in or attached to the work\n' +
        '      (an example is provided in the Appendix below).\n' +
        '\n' +
        '      "Derivative Works" shall mean any work, whether in Source or Object\n' +
        '      form, that is based on (or derived from) the Work and for which the\n' +
        '      editorial revisions, annotations, elaborations, or other modifications\n' +
        '      represent, as a whole, an original work of authorship. For the purposes\n' +
        '      of this License, Derivative Works shall not include works that remain\n' +
        '      separable from, or merely link (or bind by name) to the interfaces of,\n' +
        '      the Work and Derivative Works thereof.\n' +
        '\n' +
        '      "Contribution" shall mean any work of authorship, including\n' +
        '      the original version of the Work and any modifications or additions\n' +
        '      to that Work or Derivative Works thereof, that is intentionally\n' +
        '      submitted to Licensor for inclusion in the Work by the copyright owner\n' +
        '      or by an individual or Legal Entity authorized to submit on behalf of\n' +
        '      the copyright owner. For the purposes of this definition, "submitted"\n' +
        '      means any form of electronic, verbal, or written communication sent\n' +
        '      to the Licensor or its representatives, including but not limited to\n' +
        '      communication on electronic mailing lists, source code control systems,\n' +
        '      and issue tracking systems that are managed by, or on behalf of, the\n' +
        '      Licensor for the purpose of discussing and improving the Work, but\n' +
        '      excluding communication that is conspicuously marked or otherwise\n' +
        '      designated in writing by the copyright owner as "Not a Contribution."\n' +
        '\n' +
        '      "Contributor" shall mean Licensor and any individual or Legal Entity\n' +
        '      on behalf of whom a Contribution has been received by Licensor and\n' +
        '      subsequently incorporated within the Work.\n' +
        '\n' +
        '   2. Grant of Copyright License. Subject to the terms and conditions of\n' +
        '      this License, each Contributor hereby grants to You a perpetual,\n' +
        '      worldwide, non-exclusive, no-charge, royalty-free, irrevocable\n' +
        '      copyright license to reproduce, prepare Derivative Works of,\n' +
        '      publicly display, publicly perform, sublicense, and distribute the\n' +
        '      Work and such Derivative Works in Source or Object form.\n' +
        '\n' +
        '   3. Grant of Patent License. Subject to the terms and conditions of\n' +
        '      this License, each Contributor hereby grants to You a perpetual,\n' +
        '      worldwide, non-exclusive, no-charge, royalty-free, irrevocable\n' +
        '      (except as stated in this section) patent license to make, have made,\n' +
        '      use, offer to sell, sell, import, and otherwise transfer the Work,\n' +
        '      where such license applies only to those patent claims licensable\n' +
        '      by such Contributor that are necessarily infringed by their\n' +
        '      Contribution(s) alone or by combination of their Contribution(s)\n' +
        '      with the Work to which such Contribution(s) was submitted. If You\n' +
        '      institute patent litigation against any entity (including a\n' +
        '      cross-claim or counterclaim in a lawsuit) alleging that the Work\n' +
        '      or a Contribution incorporated within the Work constitutes direct\n' +
        '      or contributory patent infringement, then any patent licenses\n' +
        '      granted to You under this License for that Work shall terminate\n' +
        '      as of the date such litigation is filed.\n' +
        '\n' +
        '   4. Redistribution. You may reproduce and distribute copies of the\n' +
        '      Work or Derivative Works thereof in any medium, with or without\n' +
        '      modifications, and in Source or Object form, provided that You\n' +
        '      meet the following conditions:\n' +
        '\n' +
        '      (a) You must give any other recipients of the Work or\n' +
        '          Derivative Works a copy of this License; and\n' +
        '\n' +
        '      (b) You must cause any modified files to carry prominent notices\n' +
        '          stating that You changed the files; and\n' +
        '\n' +
        '      (c) You must retain, in the Source form of any Derivative Works\n' +
        '          that You distribute, all copyright, patent, trademark, and\n' +
        '          attribution notices from the Source form of the Work,\n' +
        '          excluding those notices that do not pertain to any part of\n' +
        '          the Derivative Works; and\n' +
        '\n' +
        '      (d) If the Work includes a "NOTICE" text file as part of its\n' +
        '          distribution, then any Derivative Works that You distribute must\n' +
        '          include a readable copy of the attribution notices contained\n' +
        '          within such NOTICE file, excluding those notices that do not\n' +
        '          pertain to any part of the Derivative Works, in at least one\n' +
        '          of the following places: within a NOTICE text file distributed\n' +
        '          as part of the Derivative Works; within the Source form or\n' +
        '          documentation, if provided along with the Derivative Works; or,\n' +
        '          within a display generated by the Derivative Works, if and\n' +
        '          wherever such third-party notices normally appear. The contents\n' +
        '          of the NOTICE file are for informational purposes only and\n' +
        '          do not modify the License. You may add Your own attribution\n' +
        '          notices within Derivative Works that You distribute, alongside\n' +
        '          or as an addendum to the NOTICE text from the Work, provided\n' +
        '          that such additional attribution notices cannot be construed\n' +
        '          as modifying the License.\n' +
        '\n' +
        '      You may add Your own copyright statement to Your modifications and\n' +
        '      may provide additional or different license terms and conditions\n' +
        '      for use, reproduction, or distribution of Your modifications, or\n' +
        '      for any such Derivative Works as a whole, provided Your use,\n' +
        '      reproduction, and distribution of the Work otherwise complies with\n' +
        '      the conditions stated in this License.\n' +
        '\n' +
        '   5. Submission of Contributions. Unless You explicitly state otherwise,\n' +
        '      any Contribution intentionally submitted for inclusion in the Work\n' +
        '      by You to the Licensor shall be under the terms and conditions of\n' +
        '      this License, without any additional terms or conditions.\n' +
        '      Notwithstanding the above, nothing herein shall supersede or modify\n' +
        '      the terms of any separate license agreement you may have executed\n' +
        '      with Licensor regarding such Contributions.\n' +
        '\n' +
        '   6. Trademarks. This License does not grant permission to use the trade\n' +
        '      names, trademarks, service marks, or product names of the Licensor,\n' +
        '      except as required for reasonable and customary use in describing the\n' +
        '      origin of the Work and reproducing the content of the NOTICE file.\n' +
        '\n' +
        '   7. Disclaimer of Warranty. Unless required by applicable law or\n' +
        '      agreed to in writing, Licensor provides the Work (and each\n' +
        '      Contributor provides its Contributions) on an "AS IS" BASIS,\n' +
        '      WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or\n' +
        '      implied, including, without limitation, any warranties or conditions\n' +
        '      of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A\n' +
        '      PARTICULAR PURPOSE. You are solely responsible for determining the\n' +
        '      appropriateness of using or redistributing the Work and assume any\n' +
        '      risks associated with Your exercise of permissions under this License.\n' +
        '\n' +
        '   8. Limitation of Liability. In no event and under no legal theory,\n' +
        '      whether in tort (including negligence), contract, or otherwise,\n' +
        '      unless required by applicable law (such as deliberate and grossly\n' +
        '      negligent acts) or agreed to in writing, shall any Contributor be\n' +
        '      liable to You for damages, including any direct, indirect, special,\n' +
        '      incidental, or consequential damages of any character arising as a\n' +
        '      result of this License or out of the use or inability to use the\n' +
        '      Work (including but not limited to damages for loss of goodwill,\n' +
        '      work stoppage, computer failure or malfunction, or any and all\n' +
        '      other commercial damages or losses), even if such Contributor\n' +
        '      has been advised of the possibility of such damages.\n' +
        '\n' +
        '   9. Accepting Warranty or Additional Liability. While redistributing\n' +
        '      the Work or Derivative Works thereof, You may choose to offer,\n' +
        '      and charge a fee for, acceptance of support, warranty, indemnity,\n' +
        '      or other liability obligations and/or rights consistent with this\n' +
        '      License. However, in accepting such obligations, You may act only\n' +
        '      on Your own behalf and on Your sole responsibility, not on behalf\n' +
        '      of any other Contributor, and only if You agree to indemnify,\n' +
        '      defend, and hold each Contributor harmless for any liability\n' +
        '      incurred by, or claims asserted against, such Contributor by reason\n' +
        '      of your accepting any such warranty or additional liability.\n' +
        '\n' +
        '   END OF TERMS AND CONDITIONS\n' +
        '\n' +
        '   APPENDIX: How to apply the Apache License to your work.\n' +
        '\n' +
        '      To apply the Apache License to your work, attach the following\n' +
        '      boilerplate notice, with the fields enclosed by brackets "[]"\n' +
        "      replaced with your own identifying information. (Don't include\n" +
        '      the brackets!)  The text should be enclosed in the appropriate\n' +
        '      comment syntax for the file format. We also recommend that a\n' +
        '      file or class name and description of purpose be included on the\n' +
        '      same "printed page" as the copyright notice for easier\n' +
        '      identification within third-party archives.\n' +
        '\n' +
        '   Copyright 2019-Present Atlassian Pty Ltd\n' +
        '\n' +
        '   Licensed under the Apache License, Version 2.0 (the "License");\n' +
        '   you may not use this file except in compliance with the License.\n' +
        '   You may obtain a copy of the License at\n' +
        '\n' +
        '       http://www.apache.org/licenses/LICENSE-2.0\n' +
        '\n' +
        '   Unless required by applicable law or agreed to in writing, software\n' +
        '   distributed under the License is distributed on an "AS IS" BASIS,\n' +
        '   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n' +
        '   See the License for the specific language governing permissions and\n' +
        '   limitations under the License.',
    },
    {
      packageName: '@graphql-codegen/cli',
      version: '5.0.2',
      link: 'https://github.com/dotansimha/graphql-code-generator',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2016 Dotan Simha\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: '@graphql-codegen/fragment-matcher',
      version: '5.0.2',
      link: 'https://github.com/dotansimha/graphql-code-generator',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2016 Dotan Simha\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: '@graphql-codegen/near-operation-file-preset',
      version: '3.0.0',
      link: 'https://github.com/dotansimha/graphql-code-generator',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2016 Dotan Simha\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: '@graphql-codegen/typescript',
      version: '4.0.9',
      link: 'https://github.com/dotansimha/graphql-code-generator',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2016 Dotan Simha\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: '@graphql-codegen/typescript-operations',
      version: '4.2.3',
      link: 'https://github.com/dotansimha/graphql-code-generator',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2016 Dotan Simha\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: '@testing-library/jest-dom',
      version: '6.4.8',
      link: 'https://github.com/testing-library/jest-dom',
      description:
        'The MIT License (MIT)\n' +
        'Copyright (c) 2017 Kent C. Dodds\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: '@testing-library/react',
      version: '14.2.1',
      link: 'https://github.com/testing-library/react-testing-library',
      description:
        'The MIT License (MIT)\n' +
        'Copyright (c) 2017-Present Kent C. Dodds\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: '@types/dompurify',
      version: '3.0.5',
      link: 'https://github.com/DefinitelyTyped/DefinitelyTyped',
      description:
        'This project is licensed under the MIT license.\n' +
        'Copyrights are respective of each contributor listed at the beginning of each definition file.\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: '@types/lodash.shuffle',
      version: '4.2.9',
      link: 'https://github.com/DefinitelyTyped/DefinitelyTyped',
      description:
        'This project is licensed under the MIT license.\n' +
        'Copyrights are respective of each contributor listed at the beginning of each definition file.\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: '@types/react-dom',
      version: '18.2.17',
      link: 'https://github.com/DefinitelyTyped/DefinitelyTyped',
      description:
        'This project is licensed under the MIT license.\n' +
        'Copyrights are respective of each contributor listed at the beginning of each definition file.\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: '@types/react-router-dom',
      version: '5.3.3',
      link: 'https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/react-router-dom',
      description:
        'This project is licensed under the MIT license.\n' +
        'Copyrights are respective of each contributor listed at the beginning of each definition file.\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: '@types/uuid',
      version: '9.0.8',
      link: 'https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/uuid',
      description:
        'This project is licensed under the MIT license.\n' +
        'Copyrights are respective of each contributor listed at the beginning of each definition file.\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: '@typescript-eslint/eslint-plugin',
      version: '6.12.0',
      link: 'https://github.com/typescript-eslint/typescript-eslint',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) 2019 typescript-eslint and other contributors\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'babel-jest',
      version: '29.7.0',
      link: 'https://github.com/facebook/jest',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) Meta Platforms, Inc. and affiliates.\n' +
        'Copyright Contributors to the Jest project.\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'babel-loader',
      version: '9.1.3',
      link: 'https://github.com/babel/babel-loader',
      description:
        'MIT License\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining\n' +
        'a copy of this software and associated documentation files (the\n' +
        '"Software"), to deal in the Software without restriction, including\n' +
        'without limitation the rights to use, copy, modify, merge, publish,\n' +
        'distribute, sublicense, and/or sell copies of the Software, and to\n' +
        'permit persons to whom the Software is furnished to do so, subject to\n' +
        'the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be\n' +
        'included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,\n' +
        'EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF\n' +
        'MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND\n' +
        'NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE\n' +
        'LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION\n' +
        'OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION\n' +
        'WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'copy-webpack-plugin',
      version: '11.0.0',
      link: 'https://github.com/webpack-contrib/copy-webpack-plugin',
      description:
        'Copyright JS Foundation and other contributors\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining\n' +
        'a copy of this software and associated documentation files (the\n' +
        "'Software'), to deal in the Software without restriction, including\n" +
        'without limitation the rights to use, copy, modify, merge, publish,\n' +
        'distribute, sublicense, and/or sell copies of the Software, and to\n' +
        'permit persons to whom the Software is furnished to do so, subject to\n' +
        'the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be\n' +
        'included in all copies or substantial portions of the Software.\n' +
        '\n' +
        "THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,\n" +
        'EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF\n' +
        'MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.\n' +
        'IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY\n' +
        'CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,\n' +
        'TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE\n' +
        'SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'css-loader',
      version: '6.10.0',
      link: 'https://github.com/webpack-contrib/css-loader',
      description:
        'Copyright JS Foundation and other contributors\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining\n' +
        'a copy of this software and associated documentation files (the\n' +
        "'Software'), to deal in the Software without restriction, including\n" +
        'without limitation the rights to use, copy, modify, merge, publish,\n' +
        'distribute, sublicense, and/or sell copies of the Software, and to\n' +
        'permit persons to whom the Software is furnished to do so, subject to\n' +
        'the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be\n' +
        'included in all copies or substantial portions of the Software.\n' +
        '\n' +
        "THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,\n" +
        'EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF\n' +
        'MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.\n' +
        'IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY\n' +
        'CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,\n' +
        'TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE\n' +
        'SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'eslint',
      version: '8.54.0',
      link: 'https://github.com/eslint/eslint',
      description:
        'Copyright OpenJS Foundation and other contributors, <www.openjsf.org>\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in\n' +
        'all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN\n' +
        'THE SOFTWARE.',
    },
    {
      packageName: 'eslint-config-next',
      version: '14.0.3',
      link: 'https://github.com/vercel/next.js',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2025 Vercel, Inc.\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'eslint-config-prettier',
      version: '9.0.0',
      link: 'https://github.com/prettier/eslint-config-prettier',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2017, 2018, 2019, 2020, 2021, 2022, 2023 Simon Lydell and contributors\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in\n' +
        'all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN\n' +
        'THE SOFTWARE.',
    },
    {
      packageName: 'eslint-plugin-import',
      version: '2.29.1',
      link: 'https://github.com/import-js/eslint-plugin-import',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2015 Ben Mosher\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.\n',
    },
    {
      packageName: 'eslint-plugin-prettier',
      version: '5.0.1',
      link: 'https://github.com/prettier/eslint-plugin-prettier',
      description:
        'Copyright © 2017 Andres Suarez and Teddy Katz\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the “Software”), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'eslint-plugin-unused-imports',
      version: '3.0.0',
      link: 'https://github.com/sweepline/eslint-plugin-unused-imports',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) 2022 Mikkel Holmer Pedersen\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'express',
      version: '4.21.1',
      link: 'https://github.com/expressjs/express',
      description:
        '(The MIT License)\n' +
        '\n' +
        'Copyright (c) 2009-2014 TJ Holowaychuk <tj@vision-media.ca>\n' +
        'Copyright (c) 2013-2014 Roman Shtylman <shtylman+expressjs@gmail.com>\n' +
        'Copyright (c) 2014-2015 Douglas Christopher Wilson <doug@somethingdoug.com>\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining\n' +
        'a copy of this software and associated documentation files (the\n' +
        "'Software'), to deal in the Software without restriction, including\n" +
        'without limitation the rights to use, copy, modify, merge, publish,\n' +
        'distribute, sublicense, and/or sell copies of the Software, and to\n' +
        'permit persons to whom the Software is furnished to do so, subject to\n' +
        'the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be\n' +
        'included in all copies or substantial portions of the Software.\n' +
        '\n' +
        "THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,\n" +
        'EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF\n' +
        'MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.\n' +
        'IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY\n' +
        'CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,\n' +
        'TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE\n' +
        'SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'file-loader',
      version: '6.2.0',
      link: 'https://github.com/webpack-contrib/file-loader',
      description: '',
    },
    {
      packageName: 'get-graphql-schema',
      version: '2.1.2',
      link: 'https://github.com/graphcool/get-graphql-schema',
      description:
        'Copyright JS Foundation and other contributors\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining\n' +
        'a copy of this software and associated documentation files (the\n' +
        "'Software'), to deal in the Software without restriction, including\n" +
        'without limitation the rights to use, copy, modify, merge, publish,\n' +
        'distribute, sublicense, and/or sell copies of the Software, and to\n' +
        'permit persons to whom the Software is furnished to do so, subject to\n' +
        'the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be\n' +
        'included in all copies or substantial portions of the Software.\n' +
        '\n' +
        "THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,\n" +
        'EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF\n' +
        'MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.\n' +
        'IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY\n' +
        'CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,\n' +
        'TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE\n' +
        'SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'html-webpack-plugin',
      version: '5.5.3',
      link: 'https://github.com/jantimon/html-webpack-plugin',
      description:
        'Copyright JS Foundation and other contributors\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining\n' +
        'a copy of this software and associated documentation files (the\n' +
        "'Software'), to deal in the Software without restriction, including\n" +
        'without limitation the rights to use, copy, modify, merge, publish,\n' +
        'distribute, sublicense, and/or sell copies of the Software, and to\n' +
        'permit persons to whom the Software is furnished to do so, subject to\n' +
        'the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be\n' +
        'included in all copies or substantial portions of the Software.\n' +
        '\n' +
        "THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,\n" +
        'EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF\n' +
        'MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.\n' +
        'IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY\n' +
        'CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,\n' +
        'TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE\n' +
        'SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'husky',
      version: '4.3.8',
      link: 'https://github.com/typicode/husky',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) 2021 typicode\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'identity-obj-proxy',
      version: '3.0.0',
      link: 'https://github.com/keyanzhang/identity-obj-proxy',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2015 Keyan Zhang\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.\n',
    },
    {
      packageName: 'jest',
      version: '29.7.0',
      link: 'https://github.com/facebook/jest',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) Meta Platforms, Inc. and affiliates.\n' +
        'Copyright Contributors to the Jest project.\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'jest-environment-jsdom',
      version: '29.7.0',
      link: 'https://github.com/facebook/jest',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) Meta Platforms, Inc. and affiliates.\n' +
        'Copyright Contributors to the Jest project.\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'jest-fetch-mock',
      version: '3.0.3',
      link: 'https://github.com/jefflau/jest-fetch-mock',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) 2017 Jeff Lau\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'lint-staged',
      version: '14.0.1',
      link: 'https://github.com/okonet/lint-staged',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2016 Andrey Okonetchnikov\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'mini-css-extract-plugin',
      version: '2.7.6',
      link: 'https://github.com/webpack-contrib/mini-css-extract-plugin',
      description:
        'Copyright JS Foundation and other contributors\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining\n' +
        'a copy of this software and associated documentation files (the\n' +
        "'Software'), to deal in the Software without restriction, including\n" +
        'without limitation the rights to use, copy, modify, merge, publish,\n' +
        'distribute, sublicense, and/or sell copies of the Software, and to\n' +
        'permit persons to whom the Software is furnished to do so, subject to\n' +
        'the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be\n' +
        'included in all copies or substantial portions of the Software.\n' +
        '\n' +
        "THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,\n" +
        'EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF\n' +
        'MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.\n' +
        'IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY\n' +
        'CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,\n' +
        'TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE\n' +
        'SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'node-fetch',
      version: '2',
      link: 'https://github.com/node-fetch/node-fetch',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2016 - 2020 Node Fetch Team\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'prettier',
      version: '3.0.3',
      link: 'https://github.com/prettier/prettier',
      description:
        'Copyright © James Long and contributors\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'rimraf',
      version: '5.0.5',
      link: 'https://github.com/isaacs/rimraf',
      description:
        'The ISC License\n' +
        '\n' +
        'Copyright (c) 2011-2023 Isaac Z. Schlueter and Contributors\n' +
        '\n' +
        'Permission to use, copy, modify, and/or distribute this software for any\n' +
        'purpose with or without fee is hereby granted, provided that the above\n' +
        'copyright notice and this permission notice appear in all copies.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES\n' +
        'WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF\n' +
        'MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR\n' +
        'ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES\n' +
        'WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN\n' +
        'ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR\n' +
        'IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.',
    },
    {
      packageName: 'time-fix-plugin',
      version: '2.0.7',
      link: 'https://github.com/egoist/time-fix-plugin',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) EGOIST <0x142857@gmail.com> (https://github.com/egoist)\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in\n' +
        'all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN\n' +
        'THE SOFTWARE.',
    },
    {
      packageName: 'typescript',
      version: '4.9.5',
      link: 'https://github.com/microsoft/TypeScript',
      description:
        'Apache License\n' +
        '\n' +
        'Version 2.0, January 2004\n' +
        '\n' +
        'http://www.apache.org/licenses/ \n' +
        '\n' +
        'TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION\n' +
        '\n' +
        '1. Definitions.\n' +
        '\n' +
        '"License" shall mean the terms and conditions for use, reproduction, and distribution as defined by Sections 1 through 9 of this document.\n' +
        '\n' +
        '"Licensor" shall mean the copyright owner or entity authorized by the copyright owner that is granting the License.\n' +
        '\n' +
        '"Legal Entity" shall mean the union of the acting entity and all other entities that control, are controlled by, or are under common control with that entity. For the purposes of this definition, "control" means (i) the power, direct or indirect, to cause the direction or management of such entity, whether by contract or otherwise, or (ii) ownership of fifty percent (50%) or more of the outstanding shares, or (iii) beneficial ownership of such entity.\n' +
        '\n' +
        '"You" (or "Your") shall mean an individual or Legal Entity exercising permissions granted by this License.\n' +
        '\n' +
        '"Source" form shall mean the preferred form for making modifications, including but not limited to software source code, documentation source, and configuration files.\n' +
        '\n' +
        '"Object" form shall mean any form resulting from mechanical transformation or translation of a Source form, including but not limited to compiled object code, generated documentation, and conversions to other media types.\n' +
        '\n' +
        '"Work" shall mean the work of authorship, whether in Source or Object form, made available under the License, as indicated by a copyright notice that is included in or attached to the work (an example is provided in the Appendix below).\n' +
        '\n' +
        '"Derivative Works" shall mean any work, whether in Source or Object form, that is based on (or derived from) the Work and for which the editorial revisions, annotations, elaborations, or other modifications represent, as a whole, an original work of authorship. For the purposes of this License, Derivative Works shall not include works that remain separable from, or merely link (or bind by name) to the interfaces of, the Work and Derivative Works thereof.\n' +
        '\n' +
        '"Contribution" shall mean any work of authorship, including the original version of the Work and any modifications or additions to that Work or Derivative Works thereof, that is intentionally submitted to Licensor for inclusion in the Work by the copyright owner or by an individual or Legal Entity authorized to submit on behalf of the copyright owner. For the purposes of this definition, "submitted" means any form of electronic, verbal, or written communication sent to the Licensor or its representatives, including but not limited to communication on electronic mailing lists, source code control systems, and issue tracking systems that are managed by, or on behalf of, the Licensor for the purpose of discussing and improving the Work, but excluding communication that is conspicuously marked or otherwise designated in writing by the copyright owner as "Not a Contribution."\n' +
        '\n' +
        '"Contributor" shall mean Licensor and any individual or Legal Entity on behalf of whom a Contribution has been received by Licensor and subsequently incorporated within the Work.\n' +
        '\n' +
        '2. Grant of Copyright License. Subject to the terms and conditions of this License, each Contributor hereby grants to You a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable copyright license to reproduce, prepare Derivative Works of, publicly display, publicly perform, sublicense, and distribute the Work and such Derivative Works in Source or Object form.\n' +
        '\n' +
        '3. Grant of Patent License. Subject to the terms and conditions of this License, each Contributor hereby grants to You a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable (except as stated in this section) patent license to make, have made, use, offer to sell, sell, import, and otherwise transfer the Work, where such license applies only to those patent claims licensable by such Contributor that are necessarily infringed by their Contribution(s) alone or by combination of their Contribution(s) with the Work to which such Contribution(s) was submitted. If You institute patent litigation against any entity (including a cross-claim or counterclaim in a lawsuit) alleging that the Work or a Contribution incorporated within the Work constitutes direct or contributory patent infringement, then any patent licenses granted to You under this License for that Work shall terminate as of the date such litigation is filed.\n' +
        '\n' +
        '4. Redistribution. You may reproduce and distribute copies of the Work or Derivative Works thereof in any medium, with or without modifications, and in Source or Object form, provided that You meet the following conditions:\n' +
        '\n' +
        'You must give any other recipients of the Work or Derivative Works a copy of this License; and\n' +
        '\n' +
        'You must cause any modified files to carry prominent notices stating that You changed the files; and\n' +
        '\n' +
        'You must retain, in the Source form of any Derivative Works that You distribute, all copyright, patent, trademark, and attribution notices from the Source form of the Work, excluding those notices that do not pertain to any part of the Derivative Works; and\n' +
        '\n' +
        'If the Work includes a "NOTICE" text file as part of its distribution, then any Derivative Works that You distribute must include a readable copy of the attribution notices contained within such NOTICE file, excluding those notices that do not pertain to any part of the Derivative Works, in at least one of the following places: within a NOTICE text file distributed as part of the Derivative Works; within the Source form or documentation, if provided along with the Derivative Works; or, within a display generated by the Derivative Works, if and wherever such third-party notices normally appear. The contents of the NOTICE file are for informational purposes only and do not modify the License. You may add Your own attribution notices within Derivative Works that You distribute, alongside or as an addendum to the NOTICE text from the Work, provided that such additional attribution notices cannot be construed as modifying the License. You may add Your own copyright statement to Your modifications and may provide additional or different license terms and conditions for use, reproduction, or distribution of Your modifications, or for any such Derivative Works as a whole, provided Your use, reproduction, and distribution of the Work otherwise complies with the conditions stated in this License.\n' +
        '\n' +
        '5. Submission of Contributions. Unless You explicitly state otherwise, any Contribution intentionally submitted for inclusion in the Work by You to the Licensor shall be under the terms and conditions of this License, without any additional terms or conditions. Notwithstanding the above, nothing herein shall supersede or modify the terms of any separate license agreement you may have executed with Licensor regarding such Contributions.\n' +
        '\n' +
        '6. Trademarks. This License does not grant permission to use the trade names, trademarks, service marks, or product names of the Licensor, except as required for reasonable and customary use in describing the origin of the Work and reproducing the content of the NOTICE file.\n' +
        '\n' +
        '7. Disclaimer of Warranty. Unless required by applicable law or agreed to in writing, Licensor provides the Work (and each Contributor provides its Contributions) on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied, including, without limitation, any warranties or conditions of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A PARTICULAR PURPOSE. You are solely responsible for determining the appropriateness of using or redistributing the Work and assume any risks associated with Your exercise of permissions under this License.\n' +
        '\n' +
        '8. Limitation of Liability. In no event and under no legal theory, whether in tort (including negligence), contract, or otherwise, unless required by applicable law (such as deliberate and grossly negligent acts) or agreed to in writing, shall any Contributor be liable to You for damages, including any direct, indirect, special, incidental, or consequential damages of any character arising as a result of this License or out of the use or inability to use the Work (including but not limited to damages for loss of goodwill, work stoppage, computer failure or malfunction, or any and all other commercial damages or losses), even if such Contributor has been advised of the possibility of such damages.\n' +
        '\n' +
        '9. Accepting Warranty or Additional Liability. While redistributing the Work or Derivative Works thereof, You may choose to offer, and charge a fee for, acceptance of support, warranty, indemnity, or other liability obligations and/or rights consistent with this License. However, in accepting such obligations, You may act only on Your own behalf and on Your sole responsibility, not on behalf of any other Contributor, and only if You agree to indemnify, defend, and hold each Contributor harmless for any liability incurred by, or claims asserted against, such Contributor by reason of your accepting any such warranty or additional liability.\n' +
        '\n' +
        'END OF TERMS AND CONDITIONS',
    },
    {
      packageName: 'url-loader',
      version: '4.1.1',
      link: 'https://github.com/webpack-contrib/url-loader',
      description:
        'Copyright JS Foundation and other contributors\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining\n' +
        'a copy of this software and associated documentation files (the\n' +
        "'Software'), to deal in the Software without restriction, including\n" +
        'without limitation the rights to use, copy, modify, merge, publish,\n' +
        'distribute, sublicense, and/or sell copies of the Software, and to\n' +
        'permit persons to whom the Software is furnished to do so, subject to\n' +
        'the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be\n' +
        'included in all copies or substantial portions of the Software.\n' +
        '\n' +
        "THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,\n" +
        'EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF\n' +
        'MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.\n' +
        'IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY\n' +
        'CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,\n' +
        'TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE\n' +
        'SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'webpack',
      version: '5.89.0',
      link: 'https://github.com/webpack/webpack',
      description:
        'Copyright JS Foundation and other contributors\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining\n' +
        'a copy of this software and associated documentation files (the\n' +
        "'Software'), to deal in the Software without restriction, including\n" +
        'without limitation the rights to use, copy, modify, merge, publish,\n' +
        'distribute, sublicense, and/or sell copies of the Software, and to\n' +
        'permit persons to whom the Software is furnished to do so, subject to\n' +
        'the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be\n' +
        'included in all copies or substantial portions of the Software.\n' +
        '\n' +
        "THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,\n" +
        'EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF\n' +
        'MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.\n' +
        'IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY\n' +
        'CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,\n' +
        'TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE\n' +
        'SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'webpack-cli',
      version: '5.1.4',
      link: 'https://github.com/webpack/webpack-cli',
      description:
        'Copyright JS Foundation and other contributors\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining\n' +
        'a copy of this software and associated documentation files (the\n' +
        "'Software'), to deal in the Software without restriction, including\n" +
        'without limitation the rights to use, copy, modify, merge, publish,\n' +
        'distribute, sublicense, and/or sell copies of the Software, and to\n' +
        'permit persons to whom the Software is furnished to do so, subject to\n' +
        'the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be\n' +
        'included in all copies or substantial portions of the Software.\n' +
        '\n' +
        "THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,\n" +
        'EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF\n' +
        'MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.\n' +
        'IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY\n' +
        'CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,\n' +
        'TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE\n' +
        'SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'webpack-dev-server',
      version: '4.15.1',
      link: 'https://github.com/webpack/webpack-dev-server',
      description:
        'Copyright JS Foundation and other contributors\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining\n' +
        'a copy of this software and associated documentation files (the\n' +
        "'Software'), to deal in the Software without restriction, including\n" +
        'without limitation the rights to use, copy, modify, merge, publish,\n' +
        'distribute, sublicense, and/or sell copies of the Software, and to\n' +
        'permit persons to whom the Software is furnished to do so, subject to\n' +
        'the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be\n' +
        'included in all copies or substantial portions of the Software.\n' +
        '\n' +
        "THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,\n" +
        'EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF\n' +
        'MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.\n' +
        'IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY\n' +
        'CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,\n' +
        'TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE\n' +
        'SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'webpack-manifest-plugin',
      version: '5.0.0',
      link: 'https://github.com/shellscape/webpack-manifest-plugin',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) Dane Thurber <dane.thurber@gmail.com>\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in\n' +
        'all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN\n' +
        'THE SOFTWARE.',
    },
    {
      packageName: '@emotion/babel-plugin',
      version: '11.11.0',
      link: 'https://www.npmjs.com/package/@emotion/babel-plugin',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) Emotion team and other contributors\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: '@emotion/react',
      version: '11.11.4',
      link: 'https://www.npmjs.com/package/@emotion/react',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) Emotion team and other contributors\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: '@types/jest',
      version: '27.4.1',
      link: 'https://www.npmjs.com/package/@types/jest',
      description:
        'This project is licensed under the MIT license.\n' +
        'Copyrights are respective of each contributor listed at the beginning of each definition file.\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: '@types/node',
      version: '17.0.29',
      link: 'https://www.npmjs.com/package/@types/node',
      description:
        'This project is licensed under the MIT license.\n' +
        'Copyrights are respective of each contributor listed at the beginning of each definition file.\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: '@types/react',
      version: '18.2.37',
      link: 'https://www.npmjs.com/package/@types/react',
      description:
        'This project is licensed under the MIT license.\n' +
        'Copyrights are respective of each contributor listed at the beginning of each definition file.\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'plyr',
      version: '3.7.3',
      link: 'https://www.npmjs.com/package/plyr',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2017 Sam Potts\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'react-circular-progressbar',
      version: '2.1.0',
      link: 'https://www.npmjs.com/package/react-circular-progressbar',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) 2017 Kevin Qi\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'react-indiana-drag-scroll',
      version: '2.2.0',
      link: 'https://www.npmjs.com/package/react-indiana-drag-scroll',
      description:
        'The MIT License\n' +
        '\n' +
        'Copyright (c) 2018-2019 Norserium, https://github.com/Norserium\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in\n' +
        'all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN\n' +
        'THE SOFTWARE.',
    },
    {
      packageName: 'styled-components',
      version: '6.1.8',
      link: 'https://www.npmjs.com/package/styled-components',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) 2016-present Glen Maddern and Maximilian Stoiber\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: '@parcel/config-default',
      version: '2.8.3',
      link: 'https://www.npmjs.com/package/@parcel/config-default',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) 2017-present Devon Govett\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: '@parcel/packager-ts',
      version: '2.8.3',
      link: 'https://www.npmjs.com/package/@parcel/packager-ts',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) 2017-present Devon Govett\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: '@parcel/transformer-typescript-types',
      version: '2.8.3',
      link: 'https://www.npmjs.com/package/@parcel/transformer-typescript-types',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) 2017-present Devon Govett\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: '@storybook/addon-a11y',
      version: '6.5.8',
      link: 'https://www.npmjs.com/package/@storybook/addon-a11y',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2024 Storybook\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in\n' +
        'all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN\n' +
        'THE SOFTWARE.',
    },
    {
      packageName: '@storybook/addon-essentials',
      version: '6.5.8',
      link: 'https://www.npmjs.com/package/@storybook/addon-essentials',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2024 Storybook\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in\n' +
        'all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN\n' +
        'THE SOFTWARE.',
    },
    {
      packageName: '@storybook/addon-interactions',
      version: '6.5.8',
      link: 'https://www.npmjs.com/package/@storybook/addon-interactions',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2024 Storybook\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in\n' +
        'all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN\n' +
        'THE SOFTWARE.',
    },
    {
      packageName: '@storybook/addon-links',
      version: '6.5.8',
      link: 'https://www.npmjs.com/package/@storybook/addon-links',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2024 Storybook\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in\n' +
        'all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN\n' +
        'THE SOFTWARE.',
    },
    {
      packageName: '@storybook/addon-postcss',
      version: '2.0.0',
      link: 'https://www.npmjs.com/package/@storybook/addon-postcss',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2024 Storybook\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in\n' +
        'all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN\n' +
        'THE SOFTWARE.',
    },
    {
      packageName: '@storybook/cli',
      version: '6.5.8',
      link: 'https://www.npmjs.com/package/@storybook/cli',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2024 Storybook\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in\n' +
        'all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN\n' +
        'THE SOFTWARE.',
    },
    {
      packageName: '@storybook/react',
      version: '6.5.8',
      link: 'https://www.npmjs.com/package/@storybook/react',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2024 Storybook\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in\n' +
        'all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN\n' +
        'THE SOFTWARE.',
    },
    {
      packageName: '@typescript-eslint/parser',
      version: '6.5.0',
      link: 'https://www.npmjs.com/package/@typescript-eslint/parser',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) 2019 typescript-eslint and other contributors\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'autoprefixer',
      version: '10.4.5',
      link: 'https://www.npmjs.com/package/autoprefixer',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright 2013 Andrey Sitnik <andrey@sitnik.ru>\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of\n' +
        'this software and associated documentation files (the "Software"), to deal in\n' +
        'the Software without restriction, including without limitation the rights to\n' +
        'use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of\n' +
        'the Software, and to permit persons to whom the Software is furnished to do so,\n' +
        'subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS\n' +
        'FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR\n' +
        'COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER\n' +
        'IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN\n' +
        'CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'concurrently',
      version: '8.2.2',
      link: 'https://www.npmjs.com/package/concurrently',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2015 Kimmo Brunfeldt\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'eslint-config-airbnb',
      version: '19.0.4',
      link: 'https://www.npmjs.com/package/eslint-config-airbnb',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) 2012 Airbnb\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'eslint-plugin-jsx-a11y',
      version: '6.5.1',
      link: 'https://www.npmjs.com/package/eslint-plugin-jsx-a11y',
      description:
        'The MIT License (MIT) Copyright (c) 2016 Ethan Cohen\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'eslint-plugin-react',
      version: '7.29.4',
      link: 'https://www.npmjs.com/package/eslint-plugin-react',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2014 Yannick Croissant\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'eslint-plugin-react-hooks',
      version: '4.4.0',
      link: 'https://www.npmjs.com/package/eslint-plugin-react-hooks',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) Meta Platforms, Inc. and affiliates.\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'eslint-plugin-storybook',
      version: '0.5.12',
      link: 'https://www.npmjs.com/package/eslint-plugin-storybook',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) 2022 Storybook contributors\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'identity-obj-proxy',
      version: '3.0.0',
      link: 'https://www.npmjs.com/package/identity-obj-proxy',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2015 Keyan Zhang\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'parcel',
      version: '2.8.3',
      link: 'https://www.npmjs.com/package/parcel',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) 2017-present Devon Govett\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'parcel-reporter-static-files-copy',
      version: '1.5.3',
      link: 'https://www.npmjs.com/package/parcel-reporter-static-files-copy',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) 2021 Kamil Banach <kontakt@elwin013.com>\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'parcel-resolver-tspaths',
      version: '0.0.9',
      link: 'https://www.npmjs.com/package/parcel-resolver-tspaths',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) 2021 Zach Bryant\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'react-docgen-typescript-plugin',
      version: '1.0.5',
      link: 'https://www.npmjs.com/package/react-docgen-typescript-plugin',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) Andrew Lisowski <lisowski54@gmail.com> \n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'storybook-css-modules',
      version: '1.0.8',
      link: 'https://www.npmjs.com/package/storybook-css-modules',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) 2022 OnWidget\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
    {
      packageName: 'stylelint',
      version: '15.11.0',
      link: 'https://www.npmjs.com/package/stylelint',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2015 - present Maxime Thirouin, David Clark & Richard Hallows\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of\n' +
        'this software and associated documentation files (the "Software"), to deal in\n' +
        'the Software without restriction, including without limitation the rights to\n' +
        'use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of\n' +
        'the Software, and to permit persons to whom the Software is furnished to do so,\n' +
        'subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS\n' +
        'FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR\n' +
        'COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER\n' +
        'IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN\n' +
        'CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'stylelint-config-standard',
      version: '34.0.0',
      link: 'https://www.npmjs.com/package/stylelint-config-standard',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2015 - present stylelint authors\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of\n' +
        'this software and associated documentation files (the "Software"), to deal in\n' +
        'the Software without restriction, including without limitation the rights to\n' +
        'use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of\n' +
        'the Software, and to permit persons to whom the Software is furnished to do so,\n' +
        'subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS\n' +
        'FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR\n' +
        'COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER\n' +
        'IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN\n' +
        'CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'ts-jest',
      version: '27.1.4',
      link: 'https://www.npmjs.com/package/ts-jest',
      description:
        'MIT License\n' +
        '\n' +
        'Copyright (c) 2016-2025\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.',
    },
    {
      packageName: 'ts-node',
      version: '10.7.0',
      link: 'https://www.npmjs.com/package/ts-node',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2014 Blake Embrey (hello@blakeembrey.com)\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in\n' +
        'all copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN\n' +
        'THE SOFTWARE.',
    },
    {
      packageName: 'tsconfig-paths-webpack-plugin',
      version: '3.5.2',
      link: 'https://www.npmjs.com/package/tsconfig-paths-webpack-plugin',
      description:
        'The MIT License (MIT)\n' +
        '\n' +
        'Copyright (c) 2016 Jonas Kello\n' +
        '\n' +
        'Permission is hereby granted, free of charge, to any person obtaining a copy\n' +
        'of this software and associated documentation files (the "Software"), to deal\n' +
        'in the Software without restriction, including without limitation the rights\n' +
        'to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n' +
        'copies of the Software, and to permit persons to whom the Software is\n' +
        'furnished to do so, subject to the following conditions:\n' +
        '\n' +
        'The above copyright notice and this permission notice shall be included in all\n' +
        'copies or substantial portions of the Software.\n' +
        '\n' +
        'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n' +
        'IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n' +
        'FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n' +
        'AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n' +
        'LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n' +
        'OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n' +
        'SOFTWARE.',
    },
  ],
};
